// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1Nem7","requiredAsterisk":"Info_requiredAsterisk__2q4fz"};